import React from "react";

function TotalSvgComponent(props: any) {
  return (
    <div>
      <svg
        id="circle_black_24dp"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <g id="Group_8584" data-name="Group 8584">
          <rect
            id="Rectangle_14186"
            data-name="Rectangle 14186"
            width="24"
            height="24"
            fill="none"
          />
        </g>
        <g id="Group_8585" data-name="Group 8585">
          <path
            id="Path_40088"
            data-name="Path 40088"
            d="M12,2A10,10,0,1,0,22,12,9.991,9.991,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
            fill="#276ef1"
          />
        </g>
      </svg>
    </div>
  );
}

export default TotalSvgComponent;
